import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import PropTypes from 'prop-types';
import { ErrorText } from '../ErrorText';
import {
  Container,
  Label,
  LabelContainer,
  InputContainer,
  TextInput,
  Icon,
} from './styles.js';

export const Input = forwardRef((props, ref) => {
  const inputRef = useRef();
  const {
    labelText,
    visuallyHideLabel,
    name,
    icon,
    placeholder = labelText,
    type,
    value,
    status,
    error,
    disabled = false,
    onChange,
    onBlur,
    centeredAlign,
    maxLength,
  } = props;
  const filled = value !== '';
  useImperativeHandle(ref, () => ({
    focus: () => {
      inputRef.current.focus();
    },
  }));
  return (
    <Container>
      <LabelContainer>
        <Label
          disabled={disabled}
          htmlFor={name}
          visuallyHidden={visuallyHideLabel}
        >
          {labelText}
        </Label>
        <InputContainer>
          <TextInput
            type={type}
            placeholder={placeholder}
            status={status}
            value={value}
            disabled={disabled}
            id={name}
            filled={filled}
            onChange={event => {
              onChange(event.target.value);
            }}
            name={name}
            onBlur={onBlur}
            ref={inputRef}
            centeredAlign={centeredAlign}
            maxLength={maxLength}
          />
          <Icon>{icon}</Icon>
        </InputContainer>
      </LabelContainer>
      {error && <ErrorText>{error}</ErrorText>}
    </Container>
  );
});

Input.displayName = 'Input';

Input.propTypes = {
  labelText: PropTypes.string.isRequired,
  visuallyHideLabel: PropTypes.bool,
  // Could be a tooltip component or a plain old icon
  icon: PropTypes.node,
  placeholder: PropTypes.string,
  name: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['text', 'number', 'password']),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  status: PropTypes.oneOf(['error', 'disabled']),
  error: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  centeredAlign: PropTypes.bool,
  maxLength: PropTypes.number,
};
